import React from 'react'
import Badge from '@amzn/meridian/badge'
import Tab, { TabGroup } from '@amzn/meridian/tab'
import Row from '@amzn/meridian/row'
import Text from '@amzn/meridian/text'
import { ITabToggleProps } from '../types'
import { ALL_OTHER_STORES, CURRENT_STORE } from '../constants'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import './TabToggle.scss'

/**
 * TabToggle Component
 *
 * Displays two tab options for switching between "All other stores" and "Current store" views.
 * Shows badges with count on for both tabs.
 */
export const TabToggle: React.FC<ITabToggleProps> = ({
    activeTab,
    allOtherStoresCount,
    currentStoreCount,
    onTabChange,
}) => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
        <div className="tab-toggle" data-testid="tab-toggle">
            <TabGroup
                value={activeTab}
                onChange={(value) => onTabChange(value as 'all-other-stores' | 'current-store')}
                fill="tabs"
            >
                <Tab
                    value="all-other-stores"
                    data-testid="tab-all-other-stores"
                >
                    <Row spacing="none" alignmentHorizontal="center" alignmentVertical="center">
                        <Text>{t(bundle, ALL_OTHER_STORES)}</Text>
                        <Badge
                            type="theme"
                            value={activeTab !== 'all-other-stores' ? allOtherStoresCount : undefined}
                            data-testid="badge-all-other-stores"
                        />
                    </Row>
                </Tab>
                <Tab
                    value="current-store"
                    data-testid="tab-current-store"
                >
                    <Row spacing="none" alignmentHorizontal="center" alignmentVertical="center">
                        <Text>{t(bundle, CURRENT_STORE)}</Text>
                        <Badge
                            type="theme"
                            value={activeTab !== 'current-store' ? currentStoreCount : undefined}
                            data-testid="badge-current-store"
                        />
                    </Row>
                </Tab>
            </TabGroup>
        </div>
    )
}
